import React from "react";
import PropTypes from "prop-types";
import Backdrop from "@mui/material/Backdrop";
import TopMessage from "../components/TopMessage";

export default function SocialStudioGuidanceStep({ isLiveDemo, message, closing }) {
    // Only show if Live Demo.
    const [visible, setVisible] = React.useState(true);


    if (!isLiveDemo) return null;

    return (
        <>
            {/* 🌑 Global Backdrop for Demo Guide */}
            <Backdrop
                sx={{ color: '#fff', zIndex: 1250 }} // Below raised elements (1350), above content
                open={!!message} // Open backdrop only when a specific guidance message is active (e.g., "Select Snapshot")
            />

            <TopMessage
                visible={visible}
                title={message ? "Social Studio" : "Welcome to Social Studio!"}
                subtitle={message || "Here you can create Snapshots. Click 'Create Snapshot' to try it out."}
                closing={closing}
            />
        </>
    );
}

SocialStudioGuidanceStep.propTypes = {
    isLiveDemo: PropTypes.bool,
    message: PropTypes.string,
    closing: PropTypes.bool,
};
